import { Map } from 'app/design/primitives/map';
import { getSearchAddressesRegion, type SearchAddress } from './search-addresses-map.utils';
import { useUISize } from 'app/utils/web-helpers';
import { Fragment } from 'react';

// With multiple addresses the API searches around each address's own center.
// Preview all of them without offering a single draggable center that cannot be saved.
export function SearchAddressesMap({ addresses, radius }: { addresses: SearchAddress[]; radius: number }) {
  const { isSmallUI } = useUISize();
  const validAddresses = addresses.filter(
    (address) => Number.isFinite(address.latitude) && Number.isFinite(address.longitude),
  );
  const region = getSearchAddressesRegion(validAddresses, radius);
  if (!region) return null;

  return (
    <Map
      region={region}
      width="100%"
      aspectRatio={isSmallUI ? 1.5 : 16 / 9}
      borderRadius="radius.lg"
      overflow="hidden"
      rotateEnabled={false}
    >
      {validAddresses.map((address) => (
        <Fragment key={address.id}>
          <Map.Marker coordinate={address} />
          <Map.Circle
            center={{
              latitude: address.radiusCenterLatitude ?? address.latitude,
              longitude: address.radiusCenterLongitude ?? address.longitude,
            }}
            radius={radius}
          />
        </Fragment>
      ))}
    </Map>
  );
}
